import React from "react"
import type { ReducedImage } from "types/cms"
import Image from "next/image"
import { isStorybook } from "utils/storybookUtils"
import { SixteenNine } from "packages/ui-shared/components/SixteenNine"
import { imageContainer } from "./PostHeroImage.css"

type Props = {
  image: ReducedImage
  unoptimized?: boolean
}

export const PostHeroImage: React.FC<Props> = ({ image }) => {
  if (!image) return null

  const { filename, description, src } = image
  return (
    <div className={imageContainer}>
      <SixteenNine>
        <Image
          src={src}
          title={filename}
          alt={description ?? filename}
          unoptimized={isStorybook}
          priority
          sizes="100vw"
          width={1600}
          height={900}
        />
      </SixteenNine>
    </div>
  )
}
